// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-verification-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-top: 30px;
}
.otp-verification-container .otp-section {
  display: flex;
}
.otp-verification-container .otp-section input[type=text] {
  width: 30px;
  height: 30px;
  text-align: center;
  margin-right: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.otp-verification-container .otp-cont {
  margin-bottom: 10px;
}
.otp-verification-container .email-section,
.otp-verification-container .otp-section {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.otp-verification-container .email-section input,
.otp-verification-container .otp-section input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.otp-verification-container .email-section button,
.otp-verification-container .otp-section button {
  width: 100%;
  padding: 10px;
  background: #0c3688;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.otp-verification-container .email-section button:hover,
.otp-verification-container .otp-section button:hover {
  background-color: #0056b3;
}
.otp-verification-container .email-section a,
.otp-verification-container .otp-section a {
  display: block;
  text-align: center;
  color: #0c3688;
  text-decoration: none;
  margin-top: 10px;
  cursor: pointer;
}
.otp-verification-container .email-section a:hover,
.otp-verification-container .otp-section a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/component/verificationotp/verificationOtp.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;AACR;AACQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AACZ;AAGI;EACI,mBAAA;AADR;AAII;;EAEI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFR;AAIQ;;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AADZ;AAIQ;;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AADZ;AAGY;;EACI,yBAAA;AAAhB;AAIQ;;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AADZ;AAGY;;EACI,0BAAA;AAAhB","sourcesContent":[".otp-verification-container {\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    margin-top: 30px;\n\n    .otp-section {\n        display: flex;\n\n        input[type=\"text\"] {\n            width: 30px;\n            height: 30px;\n            text-align: center;\n            margin-right: 5px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n        }\n    }\n\n    .otp-cont{\n        margin-bottom: 10px;\n    }\n\n    .email-section,\n    .otp-section {\n        margin-top: 20px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        input {\n            width: 100%;\n            padding: 10px;\n            margin-bottom: 10px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n        }\n\n        button {\n            width: 100%;\n            padding: 10px;\n            background: #0c3688;\n            color: white;\n            border: none;\n            border-radius: 4px;\n            cursor: pointer;\n            transition: background-color 0.3s;\n\n            &:hover {\n                background-color: #0056b3;\n            }\n        }\n\n        a {\n            display: block;\n            text-align: center;\n            color: #0c3688;\n            text-decoration: none;\n            margin-top: 10px;\n            cursor: pointer;\n\n            &:hover {\n                text-decoration: underline;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
